import { LitElement, html, nothing } from 'lit';
import { FsHeading } from '@cof/fs-typography-wc/fs-heading';
import typographyStyles from '@cof/fs-typography-core/lib/typography.lit.js';
import { style } from './customer-offer-banner.style.js';

import { ApplicationService } from '../../services/application.service.js';
import {
  MatchingStateEnum,
  offerStateEnum,
} from '../model/customer-offer.model.js';

export class RefiCustomerOfferBannerComponent extends LitElement {
  static styles = [style, ...FsHeading.styles, typographyStyles];

  constructor() {
    super();
    this.customerOffer = {};
    this.matchingState = '';
  }

  static properties = {
    customerOffer: { type: Object, attribute: 'customer-offer' },
    matchingState: { type: String, attribute: 'matching-state' },
  };

  get application() {
    return ApplicationService.Application;
  }

  get applicant() {
    return this.matchingState === MatchingStateEnum.coapplicant
      ? this.application.coApplicant
      : this.application.primaryApplicant;
  }

  renderMatchedOffer() {
    return html` <div class="banner-container">
        <div class="confetti-container">
          <img
            class="confetti-left"
            src="/images/left-confetti.svg"
            alt="Left confetti"
          />
          <img
            class="confetti-right"
            src="/images/right-confetti.svg"
            alt="Right confetti"
          />
        </div>

        <div class="headline-text">
          <refi-heading size="large">
            ${this.applicant.firstName}, good news!
          </refi-heading>
          <refi-heading size="large">
            Your APR of ${this.customerOffer.annualPercentRate.toFixed(2)}% is
            waiting.
          </refi-heading>
        </div>
      </div>
      <div class="headline-text">
        <refi-heading>
          <div slot="sub-header">
            Finish your pre-qualification to see the details of this special
            offer.
          </div>
        </refi-heading>
        <refi-key-requirements></refi-key-requirements>
      </div>`;
  }

  renderNewOffer() {
    return html`
      <div class="banner-container">
        <div class="alert-container">
          <fs-alert>
            We found a new special APR offer of
            ${this.customerOffer.annualPercentRate.toFixed(2)}%, but your prior
            APR offer has expired. Finish your pre-qualification to see the
            details of this new offer.
          </fs-alert>
        </div>
      </div>
    `;
  }

  renderExpiredOffer() {
    return html`
      <div class="banner-container">
        <div class="alert-container">
          <fs-alert>
            You can complete the pre-qualification to see your available
            refinance offers. Unfortunately, your special APR of
            ${this.customerOffer.annualPercentRate.toFixed(2)}% has expired.
          </fs-alert>
        </div>
      </div>
    `;
  }

  render() {
    if (this.customerOffer) {
      switch (this.customerOffer.offerState) {
        case offerStateEnum.matched:
          return html`${this.renderMatchedOffer()}`;
        case offerStateEnum.expired:
          return html`${this.renderExpiredOffer()}`;
        case offerStateEnum.new:
          return html`${this.renderNewOffer()}`;
        default:
          return nothing;
      }
    }
    return nothing;
  }
}

customElements.define(
  'refi-customer-offer-banner',
  RefiCustomerOfferBannerComponent
);
